import React, { useState, useEffect, useRef } from "react";
import filterIcon from "./img/filter.webp";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form } from "react-bootstrap";
import { useConfig } from "./ConfigContext";
import { getStaticData } from "./pureFunctions";


export default function ProjektListeOptionen({ getData, listenOptionen, setListenOptionen, users }) {
   const config = useConfig();
   const [fieldconfiguration, setFieldConfiguration] = useState({});

   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   /* 
  function addToUserList(e) {
    setListenOptionen((prev) => ({ ...prev, [e.target.value]: true }));
  }
 */

   function addToUserList(e) {
      setListenOptionen((prev) => ({
         ...prev,
         users: prev["users"] ? [...prev["users"], e.target.value] : [e.target.value],
      }));
   }
   function addToBackofficeList(e) {
      setListenOptionen((prev) => ({
         ...prev,
         [config.estate.backofficekraft]: prev[config.estate.backofficekraft]
            ? [...prev[config.estate.backofficekraft], e.target.value]
            : [e.target.value],
      }));
   }
   function addTStatusList(e) {
      setListenOptionen((prev) => ({
         ...prev,
         status: prev["status"] ? [...prev["status"], e.target.value] : [e.target.value],
      }));
   }

   useEffect(() => {
      localStorage.setItem("pListOpt", JSON.stringify(listenOptionen));
   }, [listenOptionen]);

   useEffect(() => {
      async function getAsyncData() {
         let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
         setFieldConfiguration(newfieldConfiguration);
      }
      getAsyncData();
   }, []);

   return (
      <div className="projektstatus-optionen" style={{ position: "relative", bottom: 0, right: -10, opacity: 1 }}>
         {Object.values(listenOptionen).filter((item) => item.length).length > 0 && (
            <div className="filter-indicator">
               <button
                  title="alle Filter zurücksetzen"
                  style={{ width: "50px", height: "50px", color: "#000", backgroundColor: "#fff", border: "none" }}
                  onClick={() => {
                     localStorage.setItem("pListOpt", JSON.stringify({}));
                     window.location.reload();
                  }}
               >
                  ✖
               </button>
            </div>
         )}
         <button
            onClick={handleShow}
            style={{ border: "solid 1px #fff", borderRadius: "10px 0 0 10px", filter: "invert(1)" }}
         >
            <img src={filterIcon} width="26px" />
         </button>

         <Offcanvas show={show} onHide={handleClose} placement="bottom">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
               <div className="optionen">
                  {users && (
                     <div title="Hinweis: Alle ausgewählten Optionen sind 'und'-verknüpft. Es werden die Objekte angezeigt, wo alle ausgewählten Bedingungen erfüllt sind.">
                        Von welchem Betreuer sollen Objekte sollen angezeigt werden?
                        <Form className="mt-2 mb-2">
                           <Form.Select value={""} onChange={(e) => addToUserList(e)}>
                              <option></option>
                              {Object.keys(users)
                                 .sort((a, b) => {
                                    if (users[a].Nachname + users[a].Vorname < users[b].Nachname + users[b].Vorname)
                                       return -1;
                                    if (users[a].Nachname + users[a].Vorname > users[b].Nachname + users[b].Vorname)
                                       return 1;
                                    return 0;
                                 })
                                 .map((user) => (
                                    <option key={"userOpt_" + user} value={user}>
                                       {users[user].Nachname + " " + users[user].Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form>
                        {listenOptionen.users &&
                           listenOptionen.users.map((selecteduser) => (
                              <button
                                 key={"selectedUserOpt_" + selecteduser}
                                 className="benutzer-button"
                                 name={selecteduser}
                                 onClick={(e) =>
                                    setListenOptionen((prev) => {
                                       const newListenOptionen = structuredClone(prev);
                                       newListenOptionen["users"] = newListenOptionen.users.filter(
                                          (item) => item != selecteduser,
                                       );
                                       return newListenOptionen;
                                    })
                                 }
                              >
                                 {users[selecteduser].Nachname + " " + users[selecteduser].Vorname} ×
                              </button>
                           ))}
                     </div>
                  )}

                  {users && (
                     <div title="Hinweis: Alle ausgewählten Optionen sind 'und'-verknüpft. Es werden die Objekte angezeigt, wo alle ausgewählten Bedingungen erfüllt sind.">
                        Von welcher BO-Kraft sollen Objekte sollen angezeigt werden?
                        <Form className="mt-2 mb-2">
                           <Form.Select value={""} onChange={(e) => addToBackofficeList(e)}>
                              <option></option>
                              {Object.keys(users)
                                 .sort((a, b) => {
                                    if (users[a].Nachname + users[a].Vorname < users[b].Nachname + users[b].Vorname)
                                       return -1;
                                    if (users[a].Nachname + users[a].Vorname > users[b].Nachname + users[b].Vorname)
                                       return 1;
                                    return 0;
                                 })
                                 .map((user) => (
                                    <option key={"userOpt_" + user} value={user}>
                                       {users[user].Nachname + " " + users[user].Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form>
                        {listenOptionen[config.estate.backofficekraft] &&
                           listenOptionen[config.estate.backofficekraft].map((selecteduser) => (
                              <button
                                 key={"selectedUserOpt_" + selecteduser}
                                 className="benutzer-button"
                                 name={selecteduser}
                                 onClick={(e) =>
                                    setListenOptionen((prev) => {
                                       const newListenOptionen = structuredClone(prev);
                                       newListenOptionen[config.estate.backofficekraft] = newListenOptionen[
                                          config.estate.backofficekraft
                                       ].filter((item) => item != selecteduser);
                                       return newListenOptionen;
                                    })
                                 }
                              >
                                 {users[selecteduser].Nachname + " " + users[selecteduser].Vorname} ×
                              </button>
                           ))}
                     </div>
                  )}
                  <div title="Hinweis: Alle ausgewählten Optionen sind 'und'-verknüpft. Es werden die Objekte angezeigt, wo alle ausgewählten Bedingungen erfüllt sind.">
                     Welche Status sollen angezeigt werden?
                     <Form className="mt-2 mb-2">
                        <Form.Select value={""} onChange={(e) => addTStatusList(e)}>
                           <option></option>
                           {fieldconfiguration?.estate?.status2?.permittedvalues &&
                              Object.keys(fieldconfiguration?.estate?.status2?.permittedvalues).map((status) => (
                                 <option key={"statusOpt_" + status} value={status}>
                                    {fieldconfiguration?.estate?.status2?.permittedvalues[status]}
                                 </option>
                              ))}
                        </Form.Select>
                     </Form>
                     {listenOptionen.status &&
                        listenOptionen.status.map((selectedStatus) => (
                           <button
                              key={"selectedStatusOpt_" + selectedStatus}
                              className="benutzer-button"
                              name={selectedStatus}
                              onClick={(e) =>
                                 setListenOptionen((prev) => {
                                    const newListenOptionen = structuredClone(prev);
                                    newListenOptionen["status"] = newListenOptionen.status.filter(
                                       (item) => item != selectedStatus,
                                    );
                                    return newListenOptionen;
                                 })
                              }
                           >
                              {fieldconfiguration?.estate?.status2?.permittedvalues[selectedStatus]} {" ×"}
                           </button>
                        ))}
                  </div>
                  <div>
                     Filter zurücksetzen <br />
                     <Button variant="dark" style={{ width: "150px" }} onClick={() => setListenOptionen({})}>
                        ✖
                     </Button>
                  </div>
                  <div style={{ textAlign: "center" }}>
                     Nach dem Ändern der anzuzeigenden Daten:
                     <br />
                     <Button style={{ width: "280px" }} onClick={() => getData()}>
                        aktualisieren
                     </Button>
                  </div>
               </div>
            </Offcanvas.Body>
         </Offcanvas>
      </div>
   );
}
